import React from 'react';

import { type Collectible } from '@pkg/graphql/codegen/graphql';
import { type ActiveListing } from '@pkg/types/app/marketplace/listing.ts';

import { useNFTsPageStore } from '@app/store/zustand';

import { ListEntry } from './ListEntry';
import { ListHeader } from './ListHeader';
import { ViewMoreButton } from './ViewMoreButton';

import { ScrollArea, Wrapper } from './styles';

interface Props {
    nftEntries?: Collectible[];
    activeListingData?: ActiveListing;
}

export const ListView = ({ nftEntries }: Props) => {
    const { selectedItems, handleSelectItem } = useNFTsPageStore();

    return (
        <Wrapper>
            <ScrollArea>
                <ListHeader nftEntries={nftEntries} />
                {nftEntries?.map((item) => (
                    <ListEntry
                        key={item.id}
                        item={item}
                        checked={selectedItems.includes(item.id)}
                        setChecked={() => handleSelectItem(item.id)}
                    />
                ))}
            </ScrollArea>
            <ViewMoreButton />
        </Wrapper>
    );
};
